import { ComponentStyleConfig } from '@chakra-ui/react';

export const Tag: ComponentStyleConfig = {
  baseStyle: {
    label: {
      color: 'textBase',
      fontWeight: 500,
    },
    container: {
      backgroundColor: 'M.30',
      px: 1,
      borderRadius: 'none',
      border: 'none',
    },
  },
  sizes: {
    sm: {
      container: {
        minHeight: 4,
        fontSize: 'xs',
      },
    },
    md: {
      container: {
        minHeight: 6,
        fontSize: 'xs',
      },
    },
  },
  variants: {
    outline: {
      container: {
        boxShadow: 'none',
      },
    },
    solid: {
      container: {
        backgroundColor: 'B.80',
        rounded: 'full',
        color: 'white',
      },
    },
  },
  defaultProps: {
    variant: 'outline',
  },
};
